import type { MeterBarChartTooltipProps } from '../types/meter-bar-chart.js';

export const Tooltip = (props: MeterBarChartTooltipProps) => null;

Tooltip['displayName'] = 'MeterBarChart.Tooltip';
